import { PALETTE, tokenColor } from '../styles/palette';
import { messageRecord } from '../lib/messageRecord';
import type { Crop } from '../data/types';
import { TONE_COLOR, TONE_OUTLINE, type MapLayerData } from './layers';
import { defineMessages } from '../../i18n/define';
import { tr } from '../../i18n/runtime';

const m = defineMessages({
  byCrop: {
    id: 'map.layer.crop',
    defaultMessage: 'Культуры 2026',
    description: 'Название слоя раскраски карты: по культурам сезона 2026; показывается в переключателе слоёв и заголовке легенды',
  },
  byWorkStatus: {
    id: 'map.layer.workStatus',
    defaultMessage: 'Статус работы',
    description: 'Название слоя раскраски карты: по состоянию работы на контуре',
  },
  byWater: {
    id: 'map.layer.water',
    defaultMessage: 'Вода',
    description: 'Название слоя раскраски карты: по подаче воды',
  },
  byQuarantine: {
    id: 'map.layer.quarantine',
    defaultMessage: 'Карантин',
    description: 'Название слоя раскраски карты: по карантинному статусу',
  },
  byLandCategory: {
    id: 'map.layer.landCategory',
    defaultMessage: 'Категории земель',
    description: 'Название слоя раскраски карты: по категориям земель',
  },
  byGeometry: {
    id: 'map.layer.geometry',
    defaultMessage: 'Геометрия',
    description: 'Название слоя раскраски карты: по состоянию привязки полигона',
  },
  byValues: {
    id: 'map.layer.values',
    defaultMessage: 'Значения',
    description: 'Запасное название слоя раскраски карты, когда страница не назвала свой слой',
  },
  catArableIrr: {
    id: 'map.category.arableIrr',
    defaultMessage: 'Пашня орошаемая',
    description: 'Легенда карты (подпись образца цвета, рядом с цветным квадратом): категория земли — орошаемая пашня',
  },
  catArableRain: {
    id: 'map.category.arableRain',
    defaultMessage: 'Пашня богарная',
    description: 'Легенда карты (подпись образца цвета, рядом с цветным квадратом): категория земли — богарная пашня (без полива)',
  },
  catOrchard: {
    id: 'map.category.orchard',
    defaultMessage: 'Сад',
    description: 'Легенда карты (подпись образца цвета, рядом с цветным квадратом): категория земли — сад',
  },
  catVineyard: {
    id: 'map.category.vineyard',
    defaultMessage: 'Виноградник',
    description: 'Легенда карты (подпись образца цвета, рядом с цветным квадратом): категория земли — виноградник',
  },
  catPasture: {
    id: 'map.category.pasture',
    defaultMessage: 'Пастбище',
    description: 'Легенда карты (подпись образца цвета, рядом с цветным квадратом): категория земли — пастбище',
  },
  catOther: {
    id: 'map.category.other',
    defaultMessage: 'Прочее',
    description: 'Легенда карты (подпись образца цвета, рядом с цветным квадратом): категория земли — прочее',
  },
  cropUnknown: {
    id: 'map.legend.crop.unknown',
    defaultMessage: 'Размещение неизвестно',
    description: 'Легенда карты (подпись образца цвета, рядом с цветным квадратом): на контуре неизвестно, какая культура',
  },
  cropUnknownNote: {
    id: 'map.legend.crop.unknownNote',
    defaultMessage: 'культура на 2026 не проставлена — это пробел в данных, не «пар»',
    description: 'Пояснение к строке легенды карты (мелким шрифтом под подписью): почему «неизвестно»: это пробел в данных, а не пар',
  },
  wsDone: {
    id: 'map.legend.work.done',
    defaultMessage: 'Выполнено',
    description: 'Легенда карты (подпись образца цвета, рядом с цветным квадратом): работа выполнена (внесён отчёт «выполнено»); коротко',
  },
  wsDoneNote: {
    id: 'map.legend.work.doneNote',
    defaultMessage: 'отчёт «выполнено»',
    description: 'Пояснение к строке легенды карты (мелким шрифтом под подписью): выполнено = внесён отчёт «выполнено»',
  },
  wsProgress: {
    id: 'map.legend.work.progress',
    defaultMessage: 'В процессе',
    description: 'Легенда карты (подпись образца цвета, рядом с цветным квадратом): отчёт есть, работа не закончена; коротко',
  },
  wsProgressNote: {
    id: 'map.legend.work.progressNote',
    defaultMessage: 'отчёт есть, работа не закончена',
    description: 'Пояснение к строке легенды карты (мелким шрифтом под подписью): что значит «в процессе»',
  },
  wsWindow: {
    id: 'map.legend.work.window',
    defaultMessage: 'Нет отчёта · окно идёт',
    description: 'Легенда карты (подпись образца цвета, рядом с цветным квадратом): отчёта нет, но срок работы ещё не прошёл',
  },
  wsWindowNote: {
    id: 'map.legend.work.windowNote',
    defaultMessage: 'ещё не срок',
    description: 'Пояснение к строке легенды карты (мелким шрифтом под подписью): отчёта нет, но срок не наступил',
  },
  wsUpcoming: {
    id: 'map.legend.work.upcoming',
    defaultMessage: 'Впереди',
    description: 'Легенда карты (подпись образца цвета, рядом с цветным квадратом): окно работы ещё не открылось; коротко',
  },
  wsOverdue: {
    id: 'map.legend.work.overdue',
    defaultMessage: 'После срока · нет отчёта',
    description: 'Легенда карты (подпись образца цвета, рядом с цветным квадратом): срок прошёл, отчёта нет',
  },
  wsOverdueNote: {
    id: 'map.legend.work.overdueNote',
    defaultMessage: 'отчёта не поступало — это про данные, а не про работу в поле',
    description: 'Пояснение к строке легенды карты (мелким шрифтом под подписью): после срока без отчёта: это про данные, а не вывод «не сделано»',
  },
  wsNone: {
    id: 'map.legend.work.none',
    defaultMessage: 'Работы нет',
    description: 'Легенда карты (подпись образца цвета, рядом с цветным квадратом): на контуре нет работы выбранного вида',
  },
  wsNoneNote: {
    id: 'map.legend.work.noneNote',
    defaultMessage: 'контур не входит в выборку работы',
    description: 'Пояснение к строке легенды карты (мелким шрифтом под подписью): контур не входит в выборку выбранной работы',
  },
  qDefault: {
    id: 'map.legend.quarantine.default',
    defaultMessage: 'По умолчанию зелёный',
    description: 'Легенда карты (подпись образца цвета, рядом с цветным квадратом): карантинный статус «зелёный» стоит по умолчанию',
  },
  qDefaultNote: {
    id: 'map.legend.quarantine.defaultNote',
    defaultMessage: 'карантинного основания нет — состояние по умолчанию, а не результат проверки',
    description: 'Пояснение к строке легенды карты (мелким шрифтом под подписью): зелёный по умолчанию — не результат проверки',
  },
  qWatch: {
    id: 'map.legend.quarantine.watch',
    defaultMessage: 'Под наблюдением',
    description: 'Легенда карты (подпись образца цвета, рядом с цветным квадратом): карантинный статус «жёлтый»: контур под наблюдением',
  },
  qWatchNote: {
    id: 'map.legend.quarantine.watchNote',
    defaultMessage: 'янтарная обводка и точка; основание названо в карточке контура',
    description: 'Пояснение к строке легенды карты (мелким шрифтом под подписью): как отмечен контур под наблюдением: янтарная обводка и точка',
  },
  qRed: {
    id: 'map.legend.quarantine.red',
    defaultMessage: 'Красный карантин',
    description: 'Легенда карты (подпись образца цвета, рядом с цветным квадратом): красный карантинный статус контура',
  },
  qRedNote: {
    id: 'map.legend.quarantine.redNote',
    defaultMessage: 'критичное состояние объекта — причина обязана быть названа в карточке контура',
    description: 'Пояснение к строке легенды карты (мелким шрифтом под подписью): красный статус: причина указывается в карточке контура',
  },
  gAccepted: {
    id: 'map.legend.geometry.accepted',
    defaultMessage: 'Принята',
    description: 'Легенда карты (подпись образца цвета, рядом с цветным квадратом): привязка полигона принята; коротко',
  },
  gCandidate: {
    id: 'map.legend.geometry.candidate',
    defaultMessage: 'Кандидат',
    description: 'Легенда карты (подпись образца цвета, рядом с цветным квадратом): привязка полигона — кандидат, не подтверждена; коротко',
  },
  gCandidateNote: {
    id: 'map.legend.geometry.candidateNote',
    defaultMessage: 'сопоставление не подтверждено — заливка нейтральная, медью помечена только обводка',
    description: 'Пояснение к строке легенды карты (мелким шрифтом под подписью): как отмечен кандидат: нейтральная заливка, медная обводка',
  },
  gNone: {
    id: 'map.legend.geometry.none',
    defaultMessage: 'Геометрии нет',
    description: 'Легенда карты (подпись образца цвета, рядом с цветным квадратом): у контура нет полигона',
  },
  gNoneNote: {
    id: 'map.legend.geometry.noneNote',
    defaultMessage: 'полигоном не показывается, живёт строкой в таблице-компаньоне',
    description: 'Пояснение к строке легенды карты (мелким шрифтом под подписью): контур без полигона не рисуется на карте, он есть только строкой в таблице рядом',
  },
  wDelivered: {
    id: 'map.legend.water.delivered',
    defaultMessage: 'Подано',
    description: 'Легенда карты (подпись образца цвета, рядом с цветным квадратом): вода подана полностью; коротко',
  },
  wPartial: {
    id: 'map.legend.water.partial',
    defaultMessage: 'Подано частично',
    description: 'Легенда карты (подпись образца цвета, рядом с цветным квадратом): вода подана не полностью',
  },
  wPartialNote: {
    id: 'map.legend.water.partialNote',
    defaultMessage: 'меньше 95 % запрошенного',
    description: 'Пояснение к строке легенды карты (мелким шрифтом под подписью): частично = подано меньше 95 % от запрошенного',
  },
  wNone: {
    id: 'map.legend.water.none',
    defaultMessage: 'Не подано',
    description: 'Легенда карты (подпись образца цвета, рядом с цветным квадратом): вода запрошена, но не подана',
  },
  wNoneNote: {
    id: 'map.legend.water.noneNote',
    defaultMessage: 'запрос был, подачи по учёту нет',
    description: 'Пояснение к строке легенды карты (мелким шрифтом под подписью): не подано: заявка была, в учёте подачи нет',
  },
  wUnmeasured: {
    id: 'map.legend.water.unmeasured',
    defaultMessage: 'Объём не измерен',
    description: 'Легенда карты (подпись образца цвета, рядом с цветным квадратом): объём поданной воды не измерен',
  },
  wUnmeasuredNote: {
    id: 'map.legend.water.unmeasuredNote',
    defaultMessage: 'это пробел учёта, а не ноль',
    description: 'Пояснение к строке легенды карты (мелким шрифтом под подписью): не измерен — это пробел учёта, не ноль',
  },
  wNoIrrigation: {
    id: 'map.legend.water.noIrrigation',
    defaultMessage: 'Полива нет',
    description: 'Легенда карты (подпись образца цвета, рядом с цветным квадратом): на контур полив не планировался',
  },
  wNoIrrigationNote: {
    id: 'map.legend.water.noIrrigationNote',
    defaultMessage: 'контур не входит в распределение этого полива',
    description: 'Пояснение к строке легенды карты (мелким шрифтом под подписью): контур не входит в распределение воды выбранного полива',
  },
  noValue: {
    id: 'map.legend.values.none',
    defaultMessage: 'Нет значения',
    description: 'Легенда карты (подпись образца цвета, рядом с цветным квадратом): у контура нет значения выбранного слоя (запасная подпись)',
  },
});


/** Чем красим контуры. Легенда обязательна для любого значения. */
export type ColorBy =
  | 'crop'
  | 'workStatus'
  | 'water'
  | 'quarantine'
  | 'landCategory'
  | 'geometryStatus'
  | 'values';

/**
 * Состояние работы на контуре. Значения совпадают с `Obligation.state`,
 * чтобы страница отдавала карте обязательства без перевода.
 */
export type WorkStatusValue =
  | 'reported_verified'
  | 'reported'
  /** Отчёт «в процессе»: работа начата, финального «выполнено» нет (agroai-6al.35). */
  | 'in_progress'
  | 'in_window'
  | 'upcoming'
  | 'silent';

export interface LegendEntry {
  label: string;
  color: string;
  /**
   * Значение данных, которому отвечает строка. Легенда фильтруется по факту:
   * позиции без `key` показываются всегда (служебные пояснения).
   */
  key?: string;
  /** Обводка образца: смысл не должен зависеть только от заливки. */
  outline?: string;
  dashed?: boolean;
  dotted?: boolean;
  /** Точка-маркер поверх образца: карта рисует такую же точку на контуре. */
  dot?: string;
  pattern?: 'pending' | 'demo';
  note?: string;
  /**
   * Ступень последовательной шкалы: соседние ступени легенда рисует одной
   * сплошной полосой с порогами под ней (шкала, а не список категорий).
   */
  step?: boolean;
}

/** Ключ легенды для «значения нет / не размещено / обязательства нет». */
export const LEGEND_NONE = '__none__';

export interface PaintSpec {
  title: string;
  /** Выражение MapLibre для fill-color. */
  fillColor: unknown;
  legend: LegendEntry[];
}

export const COLOR_BY_LABEL: Record<ColorBy, string> = messageRecord({
  crop: m.byCrop,
  workStatus: m.byWorkStatus,
  water: m.byWater,
  quarantine: m.byQuarantine,
  landCategory: m.byLandCategory,
  geometryStatus: m.byGeometry,
  values: m.byValues,
});

const NO_DATA = PALETTE.track;

const CATEGORY_LABEL: Record<string, string> = messageRecord<string>({
  arable_irr: m.catArableIrr,
  arable_rain: m.catArableRain,
  orchard: m.catOrchard,
  vineyard: m.catVineyard,
  pasture: m.catPasture,
  other: m.catOther,
});

const CATEGORY_COLOR: Record<string, string> = {
  arable_irr: PALETTE.active,
  arable_rain: PALETTE.bright,
  orchard: PALETTE.deep,
  vineyard: PALETTE.mint,
  pasture: PALETTE.sage,
  other: PALETTE.line,
};

/**
 * Культуры красятся собственным семейством `--crop-*` (PALETTE-SPEC.md):
 * на зелёной рампе шесть культур читались как шесть ступеней одного смысла.
 * «Размещение неизвестно» — серый `crop-unknown`, отдельный от песочного
 * «пара»: пробел в данных нельзя путать с решением не занимать поле.
 */
const CROP_UNKNOWN = PALETTE.cropUnknown;

function cropPaint(crops: Crop[]): PaintSpec {
  const known = crops.length > 0 ? crops : [];
  const match: unknown[] = ['match', ['coalesce', ['get', 'crop_2026'], 'none']];
  for (const crop of known) {
    match.push(crop.id, tokenColor(crop.color, CROP_UNKNOWN));
  }
  match.push(CROP_UNKNOWN);

  return {
    title: COLOR_BY_LABEL.crop,
    fillColor: known.length > 0 ? match : CROP_UNKNOWN,
    legend: [
      ...known.map((crop) => ({
        label: crop.name,
        key: crop.id,
        color: tokenColor(crop.color, CROP_UNKNOWN),
        outline: PALETTE.active,
      })),
      {
        label: tr(m.cropUnknown),
        key: LEGEND_NONE,
        color: CROP_UNKNOWN,
        outline: PALETTE.lineStrong,
        note: tr(m.cropUnknownNote),
      },
    ],
  };
}

/**
 * Статус работы — семантическая шкала состояния, а не ступени зелёного:
 * «окно идёт» и «впереди» на mint/sage читались как «слабее сделанного»,
 * то есть как оценка. Жёлтый `--st-progress` и нейтральный `--st-future`
 * говорят про фазу срока. Красного здесь нет и быть не может: «без отчёта»
 * — про данные, а не про работу в поле (канон).
 */
function workStatusPaint(): PaintSpec {
  return {
    title: COLOR_BY_LABEL.workStatus,
    fillColor: [
      'match',
      ['to-string', ['feature-state', 'ws']],
      ['reported', 'reported_verified'],
      PALETTE.stOk,
      'in_progress',
      PALETTE.mint,
      'in_window',
      PALETTE.stProgress,
      'upcoming',
      PALETTE.stFuture,
      'silent',
      PALETTE.stMissing,
      PALETTE.canvas,
    ],
    legend: [
      // «Выполнено ≠ отчитались» (agroai-6al.35, журнал №290): зелёный —
      // отчёт «выполнено»; отчёт «в процессе» — отдельная светлая ступень.
      { label: tr(m.wsDone), key: 'reported', color: PALETTE.stOk, note: tr(m.wsDoneNote) },
      {
        label: tr(m.wsProgress),
        key: 'in_progress',
        color: PALETTE.mint,
        outline: PALETTE.active,
        note: tr(m.wsProgressNote),
      },
      {
        label: tr(m.wsWindow),
        key: 'in_window',
        // Обводка образца тёмная, а не янтарная: янтарь по золоту дал 1,6:1
        // и образец терял край на белой карточке легенды.
        color: PALETTE.stProgress,
        outline: PALETTE.stProgressInk,
        pattern: 'pending',
        note: tr(m.wsWindowNote),
      },
      {
        label: tr(m.wsUpcoming),
        key: 'upcoming',
        color: PALETTE.stFuture,
        outline: PALETTE.muted,
        pattern: 'pending',
      },
      {
        label: tr(m.wsOverdue),
        key: 'silent',
        color: PALETTE.stMissing,
        // Обводка остаётся нейтрально-тёмной: на заливке `st-missing`
        // пунктир самим же `st-missing` был бы невидим, а смысл здесь
        // несёт именно пунктир.
        outline: PALETTE.muted,
        dotted: true,
        note: tr(m.wsOverdueNote),
      },
      {
        label: tr(m.wsNone),
        key: LEGEND_NONE,
        color: PALETTE.canvas,
        outline: PALETTE.lineStrong,
        note: tr(m.wsNoneNote),
      },
    ],
  };
}

function quarantinePaint(): PaintSpec {
  return {
    title: COLOR_BY_LABEL.quarantine,
    // Зелёный по умолчанию — mint, а не sage: sage почти совпадает с фоном
    // canvas, и слой читался как пустой район.
    // Наблюдение больше не медное: медь освобождена под кандидатность
    // (PALETTE-SPEC.md), наблюдение — янтарь `st-warn`.
    fillColor: [
      'match',
      ['to-string', ['feature-state', 'q']],
      // Ветка на будущее: красного карантина в данных трека нет, но когда
      // он появится, слой не должен молча покрасить его как «наблюдение».
      'red',
      PALETTE.stAlertSoft,
      'watch',
      PALETTE.stWarnSoft,
      'green',
      PALETTE.mint,
      PALETTE.mint,
    ],
    legend: [
      {
        label: tr(m.qDefault),
        key: 'green',
        color: PALETTE.mint,
        outline: PALETTE.active,
        note: tr(m.qDefaultNote),
      },
      {
        label: tr(m.qWatch),
        key: 'watch',
        color: PALETTE.stWarnSoft,
        outline: PALETTE.stWarn,
        dashed: true,
        dot: PALETTE.stWarn,
        note: tr(m.qWatchNote),
      },
      {
        // Позиция легенды отфильтруется, пока в данных нет ни одного
        // красного контура: легенда показывает то, что есть на карте.
        label: tr(m.qRed),
        key: 'red',
        color: PALETTE.stAlertSoft,
        outline: PALETTE.stAlert,
        dot: PALETTE.stAlert,
        note: tr(m.qRedNote),
      },
    ],
  };
}

function landCategoryPaint(): PaintSpec {
  const match: unknown[] = ['match', ['coalesce', ['get', 'category'], 'other']];
  for (const [key, color] of Object.entries(CATEGORY_COLOR)) {
    match.push(key, color);
  }
  match.push(NO_DATA);

  return {
    title: COLOR_BY_LABEL.landCategory,
    fillColor: match,
    legend: Object.entries(CATEGORY_COLOR).map(([key, color]) => ({
      label: CATEGORY_LABEL[key] ?? key,
      key,
      color,
      outline: PALETTE.active,
    })),
  };
}

/**
 * Заливка «слой выключен»: страница выбрала слой, но питать его нечем.
 * Нейтральный тон вместо цветных пятен — пояснение даёт легенда.
 */
export const SUPPRESSED_FILL: unknown = NO_DATA;

function geometryStatusPaint(): PaintSpec {
  return {
    title: COLOR_BY_LABEL.geometryStatus,
    // Кандидат не красится медью: медь у кандидата — ТОЛЬКО обводка
    // (слой contours-candidate). Заливка нейтральная, чтобы кандидат
    // визуально не поднимался до принятого факта и медь не заливала экран.
    fillColor: [
      'match',
      ['coalesce', ['get', 'geometry_status'], 'none'],
      'accepted',
      PALETTE.mint,
      'candidate',
      PALETTE.canvas,
      NO_DATA,
    ],
    legend: [
      { label: tr(m.gAccepted), key: 'accepted', color: PALETTE.mint, outline: PALETTE.deep },
      {
        label: tr(m.gCandidate),
        key: 'candidate',
        color: PALETTE.canvas,
        outline: PALETTE.copperDeep,
        dashed: true,
        note: tr(m.gCandidateNote),
      },
      {
        label: tr(m.gNone),
        key: LEGEND_NONE,
        color: 'transparent',
        outline: PALETTE.muted,
        dotted: true,
        note: tr(m.gNoneNote),
      },
    ],
  };
}

/**
 * Вода — синее семейство (ADR-0009): ирригация не зелёная и не спорит со
 * «сделано». «Не подано» — предупреждение `st-warn`, а не красный: красный
 * означает критичное состояние объекта, а не пробел подачи.
 */
function waterPaint(): PaintSpec {
  return {
    title: COLOR_BY_LABEL.water,
    fillColor: [
      'match',
      ['to-string', ['feature-state', 'v']],
      'delivered',
      PALETTE.aqua,
      'partial',
      PALETTE.aquaSoft,
      'none',
      PALETTE.stWarnSoft,
      'unmeasured',
      PALETTE.stMissing,
      PALETTE.canvas,
    ],
    legend: [
      { label: tr(m.wDelivered), key: 'delivered', color: PALETTE.aqua, outline: PALETTE.aquaDeep },
      {
        label: tr(m.wPartial),
        key: 'partial',
        color: PALETTE.aquaSoft,
        outline: PALETTE.aqua,
        note: tr(m.wPartialNote),
      },
      {
        label: tr(m.wNone),
        key: 'none',
        color: PALETTE.stWarnSoft,
        outline: PALETTE.stWarn,
        dot: PALETTE.stWarn,
        note: tr(m.wNoneNote),
      },
      {
        label: tr(m.wUnmeasured),
        key: 'unmeasured',
        color: PALETTE.stMissing,
        outline: PALETTE.muted,
        dotted: true,
        note: tr(m.wUnmeasuredNote),
      },
      {
        label: tr(m.wNoIrrigation),
        key: LEGEND_NONE,
        color: PALETTE.canvas,
        outline: PALETTE.lineStrong,
        note: tr(m.wNoIrrigationNote),
      },
    ],
  };
}

/**
 * Произвольный слой страницы: значения и легенда приходят пропсом, цвет —
 * только тоном шкалы (`DataTone`). Своих цветов страница не передаёт.
 */
function valuesPaint(data: MapLayerData | undefined): PaintSpec {
  const layer = data?.values;
  if (!layer || layer.legend.length === 0) {
    return { title: layer?.title ?? COLOR_BY_LABEL.values, fillColor: PALETTE.canvas, legend: [] };
  }
  const match: unknown[] = ['match', ['to-string', ['feature-state', 'v']]];
  for (const entry of layer.legend) match.push(entry.key, TONE_COLOR[entry.tone]);
  match.push(PALETTE.canvas);
  const pointTones = new Set(['critical', 'warning']);
  return {
    title: layer.title,
    fillColor: match,
    legend: [
      ...layer.legend.map((entry) => ({
        label: entry.label,
        key: entry.key,
        color: TONE_COLOR[entry.tone],
        outline: TONE_OUTLINE[entry.tone],
        dot: pointTones.has(entry.tone) ? TONE_OUTLINE[entry.tone] : undefined,
        note: entry.note,
        step: entry.tone.startsWith('heat-') || undefined,
      })),
      {
        label: layer.noneLabel ?? tr(m.noValue),
        key: LEGEND_NONE,
        color: PALETTE.canvas,
        outline: PALETTE.lineStrong,
      },
    ],
  };
}

export function buildPaint(colorBy: ColorBy, crops: Crop[], data?: MapLayerData): PaintSpec {
  switch (colorBy) {
    case 'crop':
      return cropPaint(crops);
    case 'workStatus':
      return workStatusPaint();
    case 'quarantine':
      return quarantinePaint();
    case 'landCategory':
      return landCategoryPaint();
    case 'geometryStatus':
      return geometryStatusPaint();
    case 'water':
      return waterPaint();
    case 'values':
      return valuesPaint(data);
  }
}
